import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    size?: number;
    color?: string;
};

const BackspaceIcon = ({ size = 48, color = 'currentColor', ...props }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none" {...props}>
            <path d="M36.6001 24H11.4001M11.4001 24L20.765 15M11.4001 24L20.765 33" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default BackspaceIcon;
